// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.3.0 (commit ).

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  AlgebraicType,
  AlgebraicValue,
  BinaryReader,
  BinaryWriter,
  ConnectionId,
  DbConnectionBuilder,
  DbConnectionImpl,
  Identity,
  ProductType,
  ProductTypeElement,
  SubscriptionBuilderImpl,
  SumType,
  SumTypeVariant,
  TableCache,
  TimeDuration,
  Timestamp,
  deepEqual,
  type CallReducerFlags,
  type DbContext,
  type ErrorContextInterface,
  type Event,
  type EventContextInterface,
  type ReducerEventContextInterface,
  type SubscriptionEventContextInterface,
} from "@clockworklabs/spacetimedb-sdk";

import { Point as __Point } from "./point_type";

export type AddAreaOfEffect = {
  tabletop: number,
  origin: __Point,
  target: __Point,
  shape: string,
};

/**
 * A namespace for generated helper functions.
 */
export namespace AddAreaOfEffect {
  /**
  * A function which returns this type represented as an AlgebraicType.
  * This function is derived from the AlgebraicType used to generate this type.
  */
  export function getTypeScriptAlgebraicType(): AlgebraicType {
    return AlgebraicType.createProductType([
      new ProductTypeElement("tabletop", AlgebraicType.createU32Type()),
      new ProductTypeElement("origin", __Point.getTypeScriptAlgebraicType()),
      new ProductTypeElement("target", __Point.getTypeScriptAlgebraicType()),
      new ProductTypeElement("shape", AlgebraicType.createStringType()),
    ]);
  }

  export function serialize(writer: BinaryWriter, value: AddAreaOfEffect): void {
    AddAreaOfEffect.getTypeScriptAlgebraicType().serialize(writer, value);
  }

  export function deserialize(reader: BinaryReader): AddAreaOfEffect {
    return AddAreaOfEffect.getTypeScriptAlgebraicType().deserialize(reader);
  }

}

